import BuyDeviceStore from './buyDevice';
import BuyVasIpProxysStore from './buyVasIpProxys';
import BuyVasNewDeviceStore from './buyVasNewDevice';
import RenewStore from './renewalDevice';

export interface ChargeOperationStoreTypes {
    BuyDeviceStore: BuyDeviceStore;
    BuyVasIpProxysStore: BuyVasIpProxysStore;
    BuyVasNewDeviceStore: BuyVasNewDeviceStore;
    RenewStore: RenewStore;
}

const ChargeOperationStore = {
    BuyDeviceStore: new BuyDeviceStore(),
    BuyVasIpProxysStore: new BuyVasIpProxysStore(),
    BuyVasNewDeviceStore: new BuyVasNewDeviceStore(),
    RenewStore: new RenewStore()
}

export default ChargeOperationStore;
